import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import "./HomeBody.css";
import ActorFilterList from "../ListItem/ActorFilterList.js";
import { FepkContext } from "../../context/FepkContext.js";

const HomeBodyActor = ({ data = [], roleLabel, emptyLabel, showRepresented = true }) => {
  const { t } = useTranslation();
  const { filterQuery } = React.useContext(FepkContext);

  const stats = useMemo(() => {
    const withPicture = data.filter((a) => a.picture);
    const withRep = withPicture.filter((a) => a.hasAgent).length;
    const cities = new Set(withPicture.map((a) => a.city).filter(Boolean)).size;
    return { total: withPicture.length, withRep, cities };
  }, [data]);

  const statItems = [
    { label: roleLabel || t("Actors"), value: stats.total },
    ...(showRepresented ? [{ label: t("Represented"), value: stats.withRep }] : []),
    { label: t("Cities"), value: stats.cities },
  ];

  return (
    <div className="tw-min-h-screen" style={{ background: "#0c0018" }}>
      {/* Stats bar */}
      <div className="tw-flex tw-justify-center tw-gap-8 tw-py-4 tw-border-b" style={{ borderColor: "rgba(90,63,73,0.3)" }}>
        {statItems.map(({ label, value }, i) => (
          <div
            key={label}
            className="stat-item tw-text-center"
            style={{ animationDelay: `${i * 0.1}s` }}
          >
            <p className="tw-text-2xl tw-font-bold tw-m-0" style={{ color: "#FF43A7" }}>
              {value}
            </p>
            <p className="tw-text-xs tw-uppercase tw-tracking-widest tw-m-0" style={{ color: "#AA8894" }}>
              {label}
            </p>
          </div>
        ))}
      </div>

      {/* Grid */}
      <div className="tw-px-4 md:tw-px-8 tw-py-6">
        <div className="tw-grid tw-gap-3 tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 lg:tw-grid-cols-5 xl:tw-grid-cols-6">
          <ActorFilterList data={data} type={filterQuery} emptyLabel={emptyLabel} />
        </div>
      </div>
    </div>
  );
};

export default HomeBodyActor;
